<template>
  <MemberAccess
    :loadingProp="loading"
    :usersProp="users"
    :invitedProp="invited"
    :memberAccessTypeProp="2"
    :changeOwnerEnabledProp="false"
  />
</template>

<script>
import MemberAccess from '@/components/_Common/MemberAccess'
import { hasImplicitOrgProjectAccess } from '@/utils/membershipPermissions'

export default {
  name: 'ProjectAccess',
  components: { MemberAccess },
  data() {
    return {
      currentObjectId: this.$store.state.projects.active.id,
      loading: true,
      invited: [],
      users: [],
    }
  },
  mounted() {
    this.$store.dispatch('invitation/load', {
      type: 'project',
      type_id: this.currentObjectId,
    })
    this.$store.dispatch('project_user/load', this.currentObjectId)
    if (this.$store.state.organisations.current.id !== 0) {
      this.$store.dispatch('organisation_user/load')
    }
  },
  watch: {
    '$store.state.project_user.list': {
      handler() {
        this.syncUsers()
      },
      deep: true,
    },
    '$store.state.organisation_user.list': {
      handler() {
        this.syncUsers()
      },
      deep: true,
    },
    '$store.state.invitation.list': {
      handler(newVal) {
        if (newVal[0] != undefined && newVal[0].type != 'Project') return
        this.invited = _.cloneDeep(newVal)
        this.loading = false
      },
      deep: true,
    },
  },
  methods: {
    syncUsers() {
      this.users = this.buildProjectAccessList()
      this.loading = false
    },
    buildProjectAccessList() {
      const projectUsers = _.cloneDeep(this.$store.state.project_user.list)
      const org = this.$store.state.organisations.current

      if (!org || org.id === 0) return projectUsers

      const seenUserIds = new Set(projectUsers.map((user) => user.user_id))
      const implicitUsers = (this.$store.state.organisation_user.list || [])
        .filter(
          (orgMember) =>
            hasImplicitOrgProjectAccess(orgMember, org) &&
            !seenUserIds.has(orgMember.user_id)
        )
        .map((orgMember) => ({
          id: `org-access-${orgMember.id}`,
          user_id: orgMember.user_id,
          email: orgMember.email,
          name: orgMember.name,
          avatar: orgMember.avatar,
          role: orgMember.role,
          organisation_id: orgMember.organisation_id,
          project_id: this.currentObjectId,
          implicit_access: true,
          invited: false,
          last_active: orgMember.last_active,
        }))

      return [...implicitUsers, ...projectUsers]
    },
  },
}
</script>
